import React from 'react'
import { useContent } from '../../contexts/ContentContext'

/**
 * BurgerButton - Animated hamburger menu button
 * Transforms from 3-line burger to X when open
 * Mini hover animation:
 * - Closed: lines rotate slightly (preview of X)
 * - Open: X rotates slightly back towards burger (preview of close)
 *
 * Props:
 * - onDark: when true, line color swaps to --color-primary-on-dark (white)
 *   for legibility over dark backgrounds. Set by FloatingBurger via scroll probe.
 */
export default function BurgerButton({ isOpen, onClick, onDark = false, className = '' }) {
  const { ui } = useContent()
  const barColor = onDark ? 'bg-primary-on-dark' : 'bg-color-primary'
  return (
    <button
      onClick={onClick}
      className={`z-[100] w-10 h-10 min-w-10 min-h-10 flex flex-col justify-center items-center gap-1.5 group ${className}`}
      aria-label={isOpen ? ui.menuOpen : ui.menuClosed}
    >
      <span
        className={`block w-6 h-0.5 ${barColor} transition-all duration-300 ease-in-out absolute ${
          isOpen
            ? 'rotate-45 group-hover:rotate-[30deg]'
            : '-translate-y-1.5 group-hover:-rotate-12'
        }`}
      />
      <span
        className={`block w-6 h-0.5 ${barColor} transition-all duration-300 ease-in-out absolute`}
        style={{ opacity: isOpen ? 0 : 1 }}
      />
      <span
        className={`block w-6 h-0.5 ${barColor} transition-all duration-300 ease-in-out absolute ${
          isOpen
            ? '-rotate-45 group-hover:-rotate-[30deg]'
            : 'translate-y-1.5 group-hover:rotate-12'
        }`}
      />
    </button>
  )
}
